export default "__VITE_ASSET__K$afODrB__"